module.exports = __webpack_public_path__ + "img/trip_03.fdd2077c.jpg";